import request from '@/utils/request'

// 查询用户列表
export function listUser(params) {
  return request({
    url: '/system/user/listTenantUser',
    method: 'get',
    params,
    headers: {
      isSaas: true
    }
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: `/system/user/detailTenantUser?userId=${userId}`,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user/addTenantUser',
    method: 'post',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user/editTenantUser',
    method: 'put',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: `/system/user/deleteTenantUser?userId=${userId}`,
    method: 'delete',
    headers: {
      isSaas: true
    }
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const url = status == 1 ? '/system/user/disableTenantUser' : '/system/user/enableTenantUser'
  return request({
    url: `${url}?userId=${userId}`,
    method: 'put',
    headers: {
      isSaas: true
    }
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: `/system/user/authRole/${userId}`,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data,
    headers: {
      isSaas: true
    }
  })
}
